import { useMutation } from "@tanstack/react-query";
import { apiRequest } from "utils/api";

export function useSignedUrl() {
  const fetchUrl = async (documentId: number): Promise<string> => {
    const response = await apiRequest("/supabase/documents/download", {
      id: documentId,
    });

    return response.signedUrl;
  };

  return useMutation({
    mutationFn: async (id: number): Promise<string> => {
      return await fetchUrl(id);
    },
  });
}
